/**
 * @generated SignedSource<<308bc64d5cad6192dae0c0aea3a57fa9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useVTOProductTypeTryonProvidersQuery$variables = Record<PropertyKey, never>;
export type useVTOProductTypeTryonProvidersQuery$data = {
  readonly tryOnProviders: {
    readonly list: ReadonlyArray<{
      readonly key: number;
      readonly value: number;
    }>;
  };
};
export type useVTOProductTypeTryonProvidersQuery = {
  response: useVTOProductTypeTryonProvidersQuery$data;
  variables: useVTOProductTypeTryonProvidersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TryOnProvidersTypesList",
    "kind": "LinkedField",
    "name": "tryOnProviders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyValuePairOfInt32AndInt64",
        "kind": "LinkedField",
        "name": "list",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useVTOProductTypeTryonProvidersQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useVTOProductTypeTryonProvidersQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "3ca1516515aa8979dbd7a7d95cddfc28",
    "id": null,
    "metadata": {},
    "name": "useVTOProductTypeTryonProvidersQuery",
    "operationKind": "query",
    "text": "query useVTOProductTypeTryonProvidersQuery {\n  tryOnProviders {\n    list {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "90dce91b88dc62081a535f5834d451ec";

export default node;
